import React from 'react';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useTranslation } from 'react-i18next';
import { faRotate, faTriangleExclamation } from '@fortawesome/pro-solid-svg-icons';
import "./style.scss";

const ErrorView = ({ eventName = "reloadData", message }) => {
    const { t } = useTranslation();

    const handleReload = () => {
        
        const reloadEvent = new CustomEvent(eventName);
        window.dispatchEvent(reloadEvent);
    };

    return (
        <div className="error-message">
            <FontAwesomeIcon icon={faTriangleExclamation} style={{ color: '#FFAA00', fontSize: '58px' }} />
            <div className='alert-text'>{message || t('errorOccurred')}</div>
            <FontAwesomeIcon
                icon={faRotate}
                style={{ fontSize: '18px', marginTop: '10px', color: '#FFAA00', cursor: 'pointer' }}
                onClick={handleReload}
            />
        </div>
    );
};

export default ErrorView;
